/* eslint-disable no-unused-vars */
import React, { useCallback, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';

export function HiddenInput(props) {
  const { em, data } = props;

  const inputProperty = {};
  if (props.data && em && em.field) {
    const _keys = em.field.split('.');
    if (_keys.length > 1) {
      inputProperty.value = (props.data && em && em.field && props.data[_keys[0]][_keys[1]]) || '';
    } else {
      inputProperty.value = (props.data && em && em.field && props.data[em.field]) || '';
    }

    // inputProperty.onChange = handleDefaultChange;
  }

  return (
    <input id={em?.id} 
      type='hidden'
      name={(em && em.field) || em?.name}
      {...inputProperty}
    />
  )
}

HiddenInput.propTypes = {
  app : PropTypes.any, 
  em : PropTypes.any, 
  data : PropTypes.any, 
}